import { SignatureType } from '@/data/user/types';
import { IChangeProfileVariables } from '@/domain/user/entities';
import { UserAuth } from '@/models/auth/UserAuth';
import { MaybeType } from '@/types';
import { create, StateCreator } from 'zustand';
import {
  createJSONStorage,
  persist,
  PersistOptions,
  devtools,
} from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type ProfileStore = {
  valAuth: MaybeType<UserAuth>;
  valProfile: MaybeType<
    IChangeProfileVariables & {
      signature?: {
        type: SignatureType;
        url: string;
        value: string;
      } | null;
    }
  >;
  setValAuth: (valAuth: MaybeType<UserAuth | any>) => void;
  setValProfile: (valProfile: MaybeType<IChangeProfileVariables>) => void;
};

type MyPersist = (
  config: StateCreator<ProfileStore>,
  options: PersistOptions<ProfileStore>,
) => StateCreator<ProfileStore>;

export const useProfileStore = create<
  ProfileStore,
  [['zustand/immer', never], ['zustand/devtools', never]]
>(
  immer(
    devtools(
      // (persist as MyPersist)(
      (set, get): ProfileStore => ({
        valAuth: undefined,
        valProfile: undefined,
        setValAuth: (valAuth: MaybeType<UserAuth>) =>
          set(state => ({ ...state, valAuth: valAuth })),
        setValProfile: (valProfile: MaybeType<IChangeProfileVariables>) =>
          set(state => ({ ...state, valProfile: valProfile })),
      }),
      // {
      //   name: 'profile-storage',
      //   storage: createJSONStorage(() => localStorage),
      // },
      // ),
    ),
  ),
);
